module.exports = __webpack_public_path__ + "img/log-out.0780d42c.svg";